import React, { useEffect, useState } from 'react';
import { initAdConfig } from '../../containers/Common/Utils';
import * as S from './AdBanner.styles';

const AdBanner = (props) => {
  useEffect(() => {
     initAdConfig();
  }, []);
  return (
    <S.Wrapper id="adPlaceHolder" styles={props.styles}>
      <S.AdBannerWrapper position={props.position}>
        <div>
          <mmtad data-cid={props.cid}></mmtad>
        </div>
      </S.AdBannerWrapper>
    </S.Wrapper>
  );
};

export default AdBanner;

// const AdBanner = () => {
//   return (
//     <S.Wrapper>
//         <S.AdBannerWrapper>
//         <S.TextWrap>
//             <S.HashText>#MyVietnam</S.HashText>
//             <S.SubText>See through the eyes of local</S.SubText>
//         </S.TextWrap>
//         <S.ExploreBtn>EXPLORE</S.ExploreBtn>
//         <S.AdTag>Ad</S.AdTag>
//         </S.AdBannerWrapper>
//     </S.Wrapper>
//   );
// };
